module.exports = __webpack_public_path__ + "static/media/mbr-1868x1920.47f16a91.png";